module.exports = __webpack_public_path__ + "img/4.67a6bf36.png";